<template>
  <mg-dialog
    :show="dialogVisible"
    title="手机验证"
    size="middle"
    @cancel="handleClose"
  >
    <div class="verification-content">
      <div class="step-one" v-if="step === 'inputPhone'">
        <p class="ver-tips">{{ verTips }}</p>
        <p class="mobile">手机号：{{ showMobile }}</p>
        <el-input
          v-model="mobile"
          placeholder="请输入手机号的后四位"
          @input="handleInputMobile"
        />
        <el-button class="btn" @click="nextStep">下一步</el-button>
      </div>
      <div class="step-two" v-else>
        <p class="ver-tips">{{ verTips }}</p>
        <el-input
          v-model="code"
          placeholder="请输入短信验证码"
          @input="handleInputCode"
        />
        <p class="count-down" v-if="countDown > 0">
          {{ countDown }}秒后可重新获取验证码
        </p>
        <div class="get-code-btn" v-else>
          <span @click="getCode">重新获取验证码</span>
        </div>
        <el-button class="btn" @click="submit">提 交</el-button>
      </div>
    </div>
  </mg-dialog>
</template>

<script>
import MgDialog from "../mg-dialog/Index.vue";
import { sendCode } from "@saas/service-api/src/phone-verification/index.js";
import ManMachineVerify, {
  isCaptchaDisasterResult,
} from "@saas/components/src/mixins/manMachineVerify";
import { uploadLiveLog } from "@saas/components/src/utils/log";

export default {
  mixins: [ManMachineVerify],
  components: { MgDialog },
  data() {
    return {
      dialogVisible: false,
      // 手机号后四位
      mobile: "",
      code: "",
      step: "inputPhone", // inputPhone, inputCode
      countDown: 60,
      timer: null,
    };
  },
  computed: {
    userInfo() {
      return this.$store.getters.user || {};
    },
    verTips() {
      if (this.step === "inputPhone") {
        return "为了保证您的账号安全请您输入当前账号的手机后四位进行校验";
      } else {
        return "短信验证码已发送至手机";
      }
    },
    showMobile() {
      return this.userInfo?.mobile?.slice(0, 3) + "********";
    },
  },
  methods: {
    open() {
      this.dialogVisible = true;
    },
    close() {
      this.dialogVisible = false;
    },
    getCode() {
      // 发送验证码前需要人机验证
      this.showCaptcha();
    },
    nextStep() {
      if (this.mobile.length !== 4) {
        this.$message.error("请输入手机后四位");
        return;
      }
      const lastMobile = this.userInfo.mobile.slice(-4);
      if (this.mobile !== lastMobile) {
        this.$message.error("手机账号不正确");
        return;
      }
      // 发送验证码前需要人机验证
      this.showCaptcha();
    },
    // 人机验证回调
    captchaCallback(res) {
      try {
        if (res.ret === 0) {
          this.sendVerifyCode(res);
        } else {
          console.log(res);
        }
      } catch (error) {
        console.log(error);
      }
    },
    sendVerifyCode(res) {
      const isCaptchaDisaster = isCaptchaDisasterResult(res);
      let params = {
        account: this.userInfo.mobile,
        randstr: res.randstr,
        scene: "DeviceBind",
        ticket: res.ticket,
      };
      uploadLiveLog(
        {
          message: "手机验证发送验证码",
          module: "user_info",
          level: "info",
          tag: "userAction",
          extra: {
            component: "PhoneVerification",
            account: this.userInfo.mobile,
            captchaDisaster: isCaptchaDisaster,
            captchaErrorCode: res.errorCode || "",
            captchaErrorMessage: res.errorMessage || "",
          },
        },
        true
      );
      sendCode(params).then((res) => {
        if (res.code === 1) {
          this.step = "inputCode";
          this.startTimer();
          this.$message.success("验证码已发送");
        } else {
          this.$message.error(res.message);
        }
      });
    },
    startTimer() {
      this.countDown = 60;
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        if (this.countDown > 0) {
          this.countDown--;
        } else {
          this.countDown = 0;
          clearInterval(this.timer);
          this.timer = null;
        }
      }, 1000);
    },
    handleInputMobile(val) {
      // 过滤掉非数字
      val = val = val.replace(/[^0-9]/g, "");
      // 限制长度
      val = val.slice(0, 4);
      this.mobile = val;
    },
    handleInputCode(val) {
      val = val.replace(/[^0-9]/g, "");
      val = val.slice(0, 6);
      this.code = val;
    },
    handleClose() {
      this.close();
    },
    submit() {
      if (this.code.length !== 6) {
        this.$message.error("请输入6位短信验证码");
        return;
      }
      this.$emit("submit", {
        account: this.userInfo.mobile,
        code: this.code,
      });
    },
  },
};
</script>

<style scoped lang="scss">
.verification-content {
  .ver-tips {
    font-weight: 400;
    font-size: 16px;
    color: #515350;
    line-height: 22px;
    padding-top: 2px;
  }
  .step-one {
    .mobile {
      margin-top: 6px;
      font-weight: 400;
      font-size: 16px;
      color: #515350;
      line-height: 22px;
      margin-bottom: 12px;
    }
  }
  .el-input ::v-deep {
    height: 50px;
    background: #ffffff;
    border-radius: 16px;
    border: 1px solid #e8e8e9;
    overflow: hidden;
    input {
      height: 50px;
      border: none;
      font-weight: 400;
      font-size: 16px;
      color: #515350;
    }
  }
  .step-two {
    .ver-tips {
      margin-bottom: 24px;
    }
    .count-down {
      margin-top: 14px;
      font-weight: 400;
      font-size: 14px;
      color: #515350;
      line-height: 20px;
    }
    .get-code-btn {
      margin-top: 14px;
      font-weight: 400;
      font-size: 14px;
      color: #00c89d;
      line-height: 20px;
      span {
        cursor: pointer;
      }
    }
  }
  .btn {
    margin-top: 32px;
    width: 100%;
    border: none;
    background: linear-gradient(132deg, #00eb81 0%, #00c89d 100%);
    border-radius: 16px;
    color: #fff;
    font-weight: 500;
    font-size: 16px;
    color: #ffffff;
    &:hover {
      background: linear-gradient(132deg, #00eb81 0%, #00c89d 100%);
    }
  }
}
</style>
